import {
  PoolConfig,
  usePool,
  useUser,
  useWeb3Provider,
} from '@trustpad/launchpad';

import React from 'react';

import {
  PancakeChartFinishedInfo,
  QuickswapChartFinishedInfo,
  SolanaChartFinishedInfo,
  UniswapChartFinishedInfo,
} from '~features/launched';

export function StandardFinishedInfo({ pool }: { pool: PoolConfig }) {
  const { web3 } = useWeb3Provider();
  const { account } = useUser();
  const { token, finishedInfo: FinishedInfo } = pool;
  const { symbol, address, chain } = token;
  const pairAddress = token.pairAddress;
  const props = { symbol, address, pairAddress };

  if (FinishedInfo) {
    return typeof FinishedInfo === 'function' ? (
      web3 && (
        <FinishedInfo web3={web3} setMessage={() => {}} account={account} />
      )
    ) : (
      <>{FinishedInfo}</>
    );
  }

  if (chain === 'BSC') {
    return <PancakeChartFinishedInfo {...props} />;
  }
  if (chain === 'POLY') {
    return <QuickswapChartFinishedInfo {...props} />;
  }
  if (chain === 'ETH') {
    return <UniswapChartFinishedInfo {...props} />;
  }
  if (chain === 'SOL') {
    return <SolanaChartFinishedInfo {...props} />;
  }
  if (chain === 'ARB') {
    return <UniswapChartFinishedInfo chain="ARB" {...props} />;
  }

  return null;
}
